export default "__VITE_ASSET__DiMxrjHA__"